import { useMediaQuery } from './useMediaQuery';

/**
 * A hook that returns whether the current window size is at or above the
 * specified Tailwind breakpoint.
 */
export const useBreakpoint = (breakpoint: 'sm' | 'md' | 'lg' | 'xl' | '2xl') => {
  const breakpoints = {
    sm: '(min-width: 640px)',
    md: '(min-width: 768px)',
    lg: '(min-width: 1024px)',
    xl: '(min-width: 1280px)',
    '2xl': '(min-width: 1536px)',
  };

  return useMediaQuery(breakpoints[breakpoint]);
};

/**
 * A more descriptive hook that returns an object containing multiple breakpoint states.
 */
export const useResponsive = () => {
  const isSm = useBreakpoint('sm');
  const isMd = useBreakpoint('md');
  const isLg = useBreakpoint('lg');
  const isXl = useBreakpoint('xl');
  const is2xl = useBreakpoint('2xl');

  return {
    isSm, // >= 640px
    isMd, // >= 768px
    isLg, // >= 1024px
    isXl, // >= 1280px
    is2xl, // >= 1536px
    isMobile: !isMd, // < 768px
    isTablet: isMd && !isLg, // 768px - 1023px
    isDesktop: isLg, // >= 1024px
  };
};
